export default __webpack_public_path__ + "static/media/proride-kids-2.5cb1f108.png";